import { RunData } from '../../types'
import { formatDistanceToNow } from 'date-fns'
import { formatDistanceConciseLocale } from './formatDistanceConciseLocale'

export function timeSinceRunFinishedInBranch(latestRun: RunData) {
  return `${formatDistanceToNow(new Date(latestRun.finished_at), { locale: { formatDistance: formatDistanceConciseLocale } })} ago - ${latestRun.branch_or_tag}`
}
